import { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import './CustomSelect.css';

const CustomSelect = ({
  value,
  onChange,
  options,
  placeholder = 'Seleccione una opción',
  disabled = false,
  name = '',
  required = false,
  title = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  // Cerrar dropdown al hacer click fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (optionValue) => {
    if (!disabled) {
      onChange({ target: { name, value: optionValue } });
      setIsOpen(false);
    }
  };

  const handleToggle = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };

  // Encontrar la opción seleccionada
  const selectedOption = options.find(opt => opt.value === value);
  const displayValue = selectedOption ? selectedOption.label : placeholder;

  return (
    <div
      className={`custom-select ${disabled ? 'disabled' : ''} ${isOpen ? 'open' : ''}`}
      ref={selectRef}
      title={title}
    >
      <div
        className="custom-select-trigger"
        onClick={handleToggle}
      >
        <span className={!selectedOption ? 'placeholder' : ''}>{displayValue}</span>
        <ChevronDown
          size={18}
          className={`custom-select-arrow ${isOpen ? 'rotated' : ''}`}
        />
      </div>

      {isOpen && !disabled && (
        <div className="custom-select-dropdown">
          {options.map((option) => (
            <div
              key={option.value}
              className={`custom-select-option ${value === option.value ? 'selected' : ''}`}
              onClick={() => handleSelect(option.value)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}

      {/* Hidden input para formularios */}
      <input
        type="hidden"
        name={name}
        value={value}
        required={required}
      />
    </div>
  );
};

export default CustomSelect;
